import axios from '@/utils/axiosInt.js'
export default { //
    click(option) { //点击量统计
        return axios.post('/bi-api/clicks/info?time=' + new Date() * 1, option)
    },
};